function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22 13.375V10.625L20.5 10.125C20 9.875 19.5 9.5 19.25 9C19 8.5 19 7.875 19.25 7.25L19.875 5.875L18 4L16.625 4.625C16.125 4.875 15.5 4.875 14.875 4.625C14.375 4.375 13.875 4 13.75 3.375L13.375 2H10.625L10.125 3.5C10 4 9.5 4.5 9 4.625C8.5 4.875 7.875 4.875 7.25 4.625L5.875 4L4 5.875L4.625 7.25C4.875 7.75 4.875 8.375 4.625 9C4.5 9.5 4 10 3.5 10.125L2 10.625V13.375L3.5 13.875C4 14.125 4.5 14.5 4.75 15C5 15.5 5 16.125 4.75 16.75L4.125 18.125L6 20L7.375 19.375C7.875 19.125 8.5 19.125 9.125 19.375C9.625 19.625 10.125 20 10.25 20.625L10.625 22H13.375L13.875 20.5C14.125 20 14.5 19.5 15 19.25C15.5 19 16.125 19 16.625 19.25L18 19.875L19.875 18L19.25 16.625C19 16.125 19 15.5 19.25 14.875C19.5 14.375 19.875 13.875 20.5 13.75L22 13.375ZM12 15.125C10.25 15.125 8.875 13.75 8.875 12C8.875 10.25 10.25 8.875 12 8.875C13.75 8.875 15.125 10.25 15.125 12C15.125 13.75 13.75 15.125 12 15.125Z",
  stroke: "#627080",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgSettings = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSettings, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Settings.ce7f7874.svg";
export { ForwardRef as ReactComponent };